/**
* @file Input component for radio input
* @author Heino Lenting
*/
import * as tslib_1 from "tslib";
import { InputBase } from '../input-base/input-base';
import { FormGroup } from '@angular/forms';
/**
 * Class for the radio input component
 */
var InputRadioComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InputRadioComponent, _super);
    /**
     * Creates an instance of InputRadioComponent.
     */
    function InputRadioComponent() {
        var _this = _super.call(this) || this;
        /** The value to be displayed. */
        _this.valueLabelKey = '';
        /** List of values and label keys of the options. */
        _this._format = undefined;
        /**
         * Indicates whether the radio buttons are aligned horizontally instead of vertically
         */
        _this.inline = false;
        _this.radioGroup = new FormGroup({});
        // Generates a random string for the HTML name attribute of the radio button tags,
        // in order to separate these radio buttons from possible other radio inputs.
        _this.name = _this.generateRandomString(8);
        return _this;
    }
    Object.defineProperty(InputRadioComponent.prototype, "format", {
        /** Gets the list of values and label keys of the options. */
        get: function () {
            return this._format;
        },
        /** Sets the options and checks whether the value is one of the options' keys. */
        set: function (value) {
            if (this._format === value) {
                return;
            }
            this._format = value;
            this.valueToLabel();
            // this.radioGroup.reset();
            // if (value == null) {
            //     return;
            // }
            // (<Array<{value: any; labelKey: string }>>value).forEach(item => {
            //     this.radioGroup.addControl(item.value + '', this.control);
            // });
        },
        enumerable: true,
        configurable: true
    });
    InputRadioComponent.prototype.setControl = function (value) {
        if (this.formControl !== value) {
            this.radioGroup.reset({});
            if (value) {
                this.radioGroup.addControl(this.name, value);
            }
        }
        _super.prototype.setControl.call(this, value);
    };
    /**
     * Sets the value and label key.
     * @param val The key of the selected value.
     */
    InputRadioComponent.prototype.setValue = function (val) {
        _super.prototype.setValue.call(this, val);
        this.valueToLabel();
    };
    /**
     * Sets the display value to the label key based on the value.
     */
    InputRadioComponent.prototype.valueToLabel = function () {
        var _this = this;
        if (!this.value || !this.format) {
            return;
        }
        var keys = Object.keys(this.format);
        var index = keys.find(function (key) { return _this.format[key].value === _this.value; });
        if (this.format[index]) {
            this.valueLabelKey = this.format[index].labelKey;
        }
    };
    /**
     * Returns a pseudo-random string.
     */
    InputRadioComponent.prototype.generateRandomString = function (length) {
        var text = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        for (var i = 0; i < length; i++) {
            text += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return text;
    };
    return InputRadioComponent;
}(InputBase));
export { InputRadioComponent };
